module.exports = __webpack_public_path__ + "static/media/bee-box.a51a1292.svg";